import { FormikErrors } from 'formik';

import extractStringsFromObj from '@/utils/extractStringsFromObj';

export default function GenericErrorDisplay({
  errors,
  showErrorsInDetail = true,
}: {
  errors: FormikErrors<any>;
  showErrorsInDetail?: boolean;
}) {
  if (!errors || Object.keys(errors).length === 0) {
    return null;
  }

  return (
    <div className="md:shadow bg-white rounded p-3 my-3 text-red-700">
      {showErrorsInDetail
        ? extractStringsFromObj(errors).map((e, i) => <div key={i}>{e}</div>)
        : 'Please fix errors before proceeding.'}
    </div>
  );
}
